import { defineStore, storeToRefs } from 'pinia'
import { auth } from '@/libs/api'
import { useFingerprint } from '@/store/fingerprint.js'
import { SessionDecorator } from '@/components/settings/security/decorators/SessionDecorator.js'
import { SESSION_TYPES } from '@/components/settings/security/decorators/BaseSession.js'

export const useAuthSessions = defineStore('authSessions', {
  state: () => ({
    sessions: [],
  }),

  actions: {
    /**
     * Receive session list
     * @return {Promise<void>}
     */
    async getSessions() {
      const { data } = await auth.getSessions()
      this.sessions = data.map((session) => SessionDecorator(session))
    },
  },
  getters: {
    /**
     * Get API token sessions (type: MANUAL)
     * @returns {Array} Array of API token sessions
     */
    apiTokenSessions: (state) =>
      state.sessions.filter((session) => session.type === SESSION_TYPES.MANUAL),

    /**
     * Get sessions by default login flow (type: LOGIN)
     * @returns {Array} Array of login flow sessions
     */
    loginSessions: (state) =>
      state.sessions.filter((session) => session.type === SESSION_TYPES.LOGIN),
    /**
     * Find active session
     * @param state
     * @return {*}
     */
    activeSession: ({ sessions }) => {
      const { visitorId } = storeToRefs(useFingerprint())
      const session = sessions.find((s) => s.fingerprint === visitorId.value)
      return session || null
    },
  },
})
